import { combineReducers } from 'redux'

import { searchbarReducer as searchbar } from './searchbar'
import { reducer as user } from './user'
import { reducer as wishlist } from './wishlist'
import { filtersReducer as filters } from './filters'

const rootReducer = combineReducers({ searchbar, user, wishlist, filters })

export default rootReducer
